import { c as _c } from "react/compiler-runtime";
import { StudioContractStandard } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const parser = parseAsStringLiteral(StudioContractStandard.map(value => toLowerCase(value)));
export function useContractStandardQueryParam(t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    shallow: t2
  } = t1;
  const shallow = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== shallow) {
    t3 = parseAsArrayOf(parser).withOptions({
      shallow
    }).withDefault([]);
    $[2] = shallow;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [contractStandards, setContractStandardsState] = useQueryState(QUERY_PARAM_KEYS.editableCollectionsContractStandard, t3);
  let t4;
  if ($[4] !== setContractStandardsState) {
    t4 = async function onSelectContractStandard(value) {
      if (!value) {
        await setContractStandardsState(null);
        return;
      }
      await setContractStandardsState([toLowerCase(value)]);
    };
    $[4] = setContractStandardsState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onSelectContractStandard = t4;
  let t5;
  if ($[6] !== setContractStandardsState) {
    t5 = async function setContractStandards(values) {
      await setContractStandardsState(values?.length ? [toLowerCase(values[0])] : null);
    };
    $[6] = setContractStandardsState;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const setContractStandards = t5;
  let t6;
  if ($[8] !== contractStandards[0]) {
    t6 = contractStandards[0] ? toUpperCase(contractStandards[0]) : undefined;
    $[8] = contractStandards[0];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== contractStandards) {
    t7 = contractStandards.map(toUpperCase);
    $[10] = contractStandards;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onSelectContractStandard || $[13] !== setContractStandards || $[14] !== t6 || $[15] !== t7) {
    t8 = {
      contractStandard: t6,
      contractStandards: t7,
      onSelectContractStandard,
      setContractStandards
    };
    $[12] = onSelectContractStandard;
    $[13] = setContractStandards;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}